export enum LessonProgressStatus {
    NotStarted,
    InProgress,
    Finished,
    Canceled
}